import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 65 65',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M40.5,73A32.5,32.5,0,1,0,8,40.5,32.494,32.494,0,0,0,40.5,73ZM12.194,40.5A28.306,28.306,0,1,1,40.5,68.806,28.305,28.305,0,0,1,12.194,40.5Zm43.469-2.359L32.6,24.119a3.151,3.151,0,0,0-4.678,2.752V54.129A3.153,3.153,0,0,0,32.6,56.881L55.662,43.645A3.155,3.155,0,0,0,55.662,38.141ZM32.113,50.958V30.134a.78.78,0,0,1,1.193-.668L50.931,40.172a.786.786,0,0,1-.013,1.35L33.292,51.639A.788.788,0,0,1,32.113,50.958Z"
          transform="translate(-8 -8)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
